import React from "react"
import LazyImage from "../../components/LazyImage"
import AppLink from "../../components/AppLink"
import "./index.scss"
import ArrowRight from "../../components/icons/ArrowRight"
import { NAVIGATION_LINKS } from "../../constants/common"

export const PeopleCard = ({ name, text, image, link, call }) => {
    return (
        <div className="people-card">
            <div className="people-card-image">
                <LazyImage alt={name} src={image} />
                <h4 className="t-s1">{name}</h4>
                <hr />
                <h6 className="t-b3">{text}</h6>
                <AppLink className="people-card-image-linkedin hov-get-in-touch-white" href={link}>Linkedin</AppLink>
                {call && window.location.pathname !== NAVIGATION_LINKS.ABOUT_US &&
                <AppLink
                    className="people-card-book-call t-nav hov-get-in-touch-white"
                    href={call}
                >
                    Book a call <ArrowRight width={26} />
                </AppLink>
                }
            </div>
        </div>
    )
}
